var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIconGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.6708 16.0848L14.1863 12.6006C16.7918 9.1165 16.0815 4.18034 12.597 1.57163C9.11246 -1.03708 4.17576 -0.323381 1.57029 3.15724C-1.03519 6.63787 -0.324926 11.5811 3.15608 14.1863C5.95494 16.2817 9.79811 16.2817 12.597 14.1863L16.0815 17.6704C16.521 18.1099 17.2313 18.1099 17.6673 17.6704C18.1103 17.2344 18.1103 16.5243 17.6708 16.0848ZM7.90641 13.5147C4.80867 13.5147 2.29813 11.0045 2.29813 7.90707C2.29813 4.80966 4.81219 2.30291 7.90641 2.30291C11.0006 2.30291 13.5147 4.81318 13.5147 7.91058C13.5112 11.0045 11.0042 13.5112 7.90641 13.5147Z",
    fill: "#C0C0C0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIconGray);
export default __webpack_public_path__ + "static/media/searchIconGray.ea9d8e1bcb3680ab0ce7dbd164b7c28f.svg";
export { ForwardRef as ReactComponent };